import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HelperViewStatus,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import * as trackEvents from '@/modules/transaction/views/NewTransfer/track-events';

interface Props {
  isOpen: boolean;
  description: string;
  isLoading?: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'schedule-withdraw'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleModal',
  props: {
    isOpen: { type: Boolean },
    description: null,
    isLoading: { type: Boolean, default: false }
  },
  emits: ["close", "schedule-withdraw"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'schedule-withdraw'): void;
}), expose: any, slots: any, attrs: any }) {





function emitClose() {
  trackEvents.trackScheduleDismissTransferClick();
  emit('close');
}
function emitScheduleWithdraw() {
  trackEvents.trackScheduleTransferPopupClick();
  emit('schedule-withdraw');
}

return { __sfc: true,emit, emitClose, emitScheduleWithdraw, Modal, HelperViewStatus, ButtonPrimary }
}

})